import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs whent the authroization token is invalid.
 */
export class MissingTokenException extends CoreUiException {

    /**
     * Is true if its been handled already
     */
    tokenErrorHandled = false;

    constructor(message?: string, originalError?: any) {

        super("MissingToken", message || "You are not logged in. Please login.", originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, MissingTokenException.prototype);
    }
}
